import React, { useContext, useState } from "react";
import SceneKanji from "./SceneKanji";
import SceneSettings from "./SceneSettings";
window.$mode = "1"//1K 2En

const Main = () => {
	const [scene, setScene] = useState(0);

	function handleCallback(s) {
		setScene(s);
		// alert("You SET me!" + s);
	}

	function C_Center() {
		if (scene == 1) {
			return <SceneSettings parentData={scene} parentCallback={handleCallback} />;
		} else {
			return <SceneKanji parentData={scene} parentCallback={handleCallback} />;
		}
	}

	return C_Center();
};

export default Main;